/**
 * Finds the nearest ancestor that actually scrolls (has overflow and
 * content taller than its viewport).
 */
const findScrollableAncestor = (el: HTMLElement): HTMLElement | null => {
  let current = el.parentElement;
  while (current) {
    const style = getComputedStyle(current);
    const overflowY = style.overflowY;
    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      current.scrollHeight > current.clientHeight
    ) {
      return current;
    }
    current = current.parentElement;
  }
  return null;
};

/**
 * Scrolls `target` into the vertical center of its nearest scrollable
 * ancestor (or `containerHint` if it's actually scrollable) without
 * affecting any other scroll positions.
 */
export const scrollToTarget = (
  containerHint: HTMLElement | null,
  target: HTMLElement | null,
  behavior: ScrollBehavior = "smooth",
) => {
  if (!target) return;
  const container =
    (containerHint && containerHint.scrollHeight > containerHint.clientHeight)
      ? containerHint
      : findScrollableAncestor(target);
  if (!container) return;
  const targetRect = target.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  container.scrollTo({
    top: container.scrollTop + (targetRect.top - containerRect.top) - containerRect.height / 2,
    behavior,
  });
};
